
export default errors => errors.map(error => (error.detail ? error.detail : error))
